import { QuestionCircleTwoTone } from '@ant-design/icons';
import styled from 'styled-components';

export const StyledDiv = styled.div`
  height: 100%;
`;

export const StyledCarouselWrapper = styled.div<{ $innerHeight?: string }>`
  position: relative;
  height: 100%;

  .ant-carousel {
    height: ${({ $innerHeight }) => $innerHeight ?? 'unset'};
    background-color: ${({ theme }) => theme.gray};
  }
`;

export const StyledQuestionCircleTwoTone = styled(QuestionCircleTwoTone)<{
  $isInCarousel: boolean;
}>`
  cursor: pointer;
  position: absolute;
  bottom: ${({ $isInCarousel }) => ($isInCarousel ? 'calc(24px + 1em)' : '1em')};
  right: 1em;
`;

export const EmptyImage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;
